import BaseAction from "../base-action";
import {ActionTypeEnum} from "../../base/training-literals";

class ExplodeModel extends BaseAction {
    model;
    unit;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.EXPLODE_MODEL;
        this.model = props.model || "";
        this.unit = props.unit || 0;
    }

    get(props = {}) {
        return {
            type: this.actionType,
            model: props.model || this.model,
            unit: props.unit || this.unit,
            duration: props.duration || this.duration
        }
    }
}

export default ExplodeModel;